import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AdminPage from "../pages/admin/page";
import AdminAuthGate from "../pages/admin/components/AdminAuthGate";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  {
    path: "/admin",
    element: (
      <AdminAuthGate>
        <AdminPage />
      </AdminAuthGate>
    ),
  },
  { path: "*", element: <NotFound /> },
];

export default routes;
